import { AppProviders } from '@/app/providers/AppProviders';
import { AppRouter } from '@/app/router/AppRouter';

/**
 * Composition only. Providers wrap the route table and nothing else lives here —
 * screens belong in `features/`, shared pieces in `components/`.
 */
export function App() {
  return (
    <AppProviders>
      <AppRouter />
    </AppProviders>
  );
}
